import { render, staticRenderFns } from "./AdminCaarj.vue?vue&type=template&id=dc50d540"
import script from "./AdminCaarj.vue?vue&type=script&lang=js"
export * from "./AdminCaarj.vue?vue&type=script&lang=js"
import style0 from "./AdminCaarj.vue?vue&type=style&index=0&id=dc50d540&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports